/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис связей помещений и пользователей
 */

/**
 * Сервис управления доступом пользователей
 */
export class RoomUserServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения списка связей помещений и пользователей.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetRoomUserList = (req?: GetRoomUserListRequestDto, init?: RequestInit): Promise<GetRoomUserListResponseDto[]> => {
    return fm.list<GetRoomUserListRequestDto, GetRoomUserListResponseDto>(`${this.host}/access_control/api/v1/room/user/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей помещений и пользователей.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetRoomUserCount = (req?: GetRoomUserCountRequestDto, init?: RequestInit): Promise<GetRoomUserCountResponseDto> => {
    return fm.request<GetRoomUserCountRequestDto, GetRoomUserCountResponseDto>(`${this.host}/access_control/api/v1/room/user/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum RoomUserPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type RoomUserPagingDirectionTypeResponseEnum = keyof typeof RoomUserPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type RoomUserPagingDirectionTypeRequestEnum = Exclude<RoomUserPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum RoomUserPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  USER_ID = "USER_ID",
  /**
   * По ОРПОНу и номеру
   */
  ORPON_THEN_NUMBER = "ORPON_THEN_NUMBER",
}
/**
 * Справочник типов значений сортировки.
 */
export type RoomUserPagingOrderByTypeResponseEnum = keyof typeof RoomUserPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type RoomUserPagingOrderByTypeRequestEnum = Exclude<RoomUserPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества связей помещений и пользователей
 */
export type GetRoomUserCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: RoomUserFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей помещений и пользователей
 */
export type GetRoomUserCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка связей помещений и пользователей
 */
export type GetRoomUserListRequestDto = {
  /**
   * Фильтр
   */
  filter?: RoomUserFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: RoomUserPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей помещений и пользователей
 */
export type GetRoomUserListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь помещения и пользователя
   */
  readonly data: RoomUserResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRoomUserListResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRoomUserListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRoomUserListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Связь помещения и пользователя
 */
export type RoomUserRequestDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
  /**
   * Идентификатор пользователя.
   * # Диапазон: 1..2147483647
   */
  userId: number
}
/**
 * Связь помещения и пользователя
 */
export type RoomUserResponseDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
  /**
   * Идентификатор пользователя.
   * # Диапазон: 1..2147483647
   */
  userId: number
}
/**
 * Фильтр по связям помещений и пользователей
 */
export type RoomUserFilterRequestDto = {
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * По номерам квартир
   */
  roomNumbers?: string[]
  /**
   * По идентификаторам пользователей
   */
  userIds?: number[]
}
/**
 * Фильтр по связям помещений и пользователей
 */
export type RoomUserFilterResponseDto = {
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * По номерам квартир
   */
  roomNumbers: string[]
  /**
   * По идентификаторам пользователей
   */
  userIds: number[]
}
/**
 * Постраничный вывод
 */
export type RoomUserPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: USER_ID
   */
  orderByType?: RoomUserPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: RoomUserPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type RoomUserPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: USER_ID
   */
  orderByType: RoomUserPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: RoomUserPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества связей помещений и пользователей
   */
  "GetRoomUserCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей помещений и пользователей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RoomUserFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей помещений и пользователей
   */
  "GetRoomUserCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей помещений и пользователей",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос получения списка связей помещений и пользователей
   */
  "GetRoomUserListRequest": {
    "kind": "class",
    "text": "Запрос получения списка связей помещений и пользователей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RoomUserFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "RoomUserPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей помещений и пользователей
   */
  "GetRoomUserListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей помещений и пользователей",
    "fields": {
      /**
       * Связь помещения и пользователя
       */
      "data": {
        "type": "RoomUser",
        "text": "Связь помещения и пользователя",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRoomUserListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRoomUserListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Связь помещения и пользователя
   */
  "RoomUser": {
    "kind": "class",
    "text": "Связь помещения и пользователя",
    "fields": {
      /**
       * ОРПОН дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
      /**
       * Идентификатор пользователя.
       * # Диапазон: 1..2147483647
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр по связям помещений и пользователей
   */
  "RoomUserFilter": {
    "kind": "class",
    "text": "Фильтр по связям помещений и пользователей",
    "fields": {
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * По номерам квартир
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам квартир",
      },
      /**
       * По идентификаторам пользователей
       */
      "userIds": {
        "type": "int32",
        "text": "По идентификаторам пользователей",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "RoomUserPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: USER_ID
       */
      "orderByType": {
        "type": "RoomUserPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: USER_ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "RoomUserPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "RoomUserPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "RoomUserPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "USER_ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По ОРПОНу и номеру
       */
      "ORPON_THEN_NUMBER": {
        "i": 2,
        "text": "По ОРПОНу и номеру",
      },
    },
  },
}